









































































































































































































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import PxTextEntryBox from "@/views/components/input/formFields/PxTextEntryBox.vue";
import PxTextArea from "@/views/components/input/formFields/PxTextArea.vue";
import PxDropdown from "@/views/components/input/formFields/PxDropdown.vue";
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";

import {perRoadStore} from "@/store/store";
import {states} from "@/lib/data/states";
import SeasonRow from "@/modules/perRoad/views/components/SeasonRow.vue";
import {UnitSystem} from "@/interfaces/units";
import RoadwayClassificationEditor from "@/modules/perRoad/views/components/traffic/RoadwayClassificationEditor.vue";
import PrVehicleDistributionPlot from "@/modules/perRoad/views/components/traffic/PrVehicleDistributionPlot.vue";
import PrAxleLoadDistributionPlot from "@/modules/perRoad/views/components/traffic/PrAxleLoadDistributionPlot.vue";
import {getNewLoadDistribution} from "@/modules/perRoad/lib/roadwayFunctionalClassifications";
import {PrAxleConfigurationType} from "@/modules/perRoad/interfaces/perRoad";
import {createPerRoadValidations} from "@/modules/perRoad/lib/validations";

Component.registerHooks(["validations"]);

@Component({
  components: {
    PrAxleLoadDistributionPlot,
    PrVehicleDistributionPlot,
    RoadwayClassificationEditor,
    SeasonRow,
    PxNumberInput,
    PxTextEntryBox,
    PxTextArea,
    PxDropdown,
  },
})
export default class PerRoadTraffic extends Vue {
  @Prop() readonly id!: string;

  @Prop() readonly page!: number;

  stateOptions = states;

  plotKey = 0;

  axleDistPlotKey = 0;

  incrementPlotKey() {
    this.plotKey += 1;
    this.axleDistPlotKey += 1;
  }

  get scenario() {
    return perRoadStore.currentScenario;
  }

  get scenarioImperial() {
    return perRoadStore.currentImperial;
  }

  get isImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial;
  }

  /**
   * Vehicle Distribution
   */

  setVehicleDistribution() {
    this.setAxleStats();
    this.normalizeLoading();
    this.sync();
  }

  /**
   * Loading config percents
   */

      // AADT % * average number of single axles per vehicle
  singlePct: number = 0;

  tandemPct: number = 0;

  tridemPct: number = 0;

  steerPct: number = 0;

  setAxleStats() {
    /**
     * Get the weighted sum of axle counts for each configuration types.
     */
    this.singlePct = this.scenario.vehiclesPctAadt.map(
        (pct, i) => (pct / 100) * this.scenario.vehicleAxlesSingle[i],
    ).reduce((a, b) => a + b, 0);

    this.tandemPct = this.scenario.vehiclesPctAadt.map(
        (pct, i) => (pct / 100) * this.scenario.vehicleAxlesTandem[i],
    ).reduce((a, b) => a + b, 0);

    this.tridemPct = this.scenario.vehiclesPctAadt.map(
        (pct, i) => (pct / 100) * this.scenario.vehicleAxlesTridem[i],
    ).reduce((a, b) => a + b, 0);

    this.steerPct = this.scenario.vehiclesPctAadt.map(
        (pct, i) => (pct / 100) * this.scenario.vehicleAxlesSteer[i],
    ).reduce((a, b) => a + b, 0);

    this.normalizeLoading();
  }

  get normalizeRequired() {
    // Normalization required if outside the tolerance bound
    const tol = 0.01; // Percent
    return Math.abs(
        (this.scenario.axleSingleEnabled ? this.singlePct : 0)
        + (this.scenario.axleTandemEnabled ? this.tandemPct : 0)
        + (this.scenario.axleTridemEnabled ? this.tridemPct : 0)
        + (this.scenario.axleSteerEnabled ? this.steerPct : 0)
        - 100,
    ) > tol;
  }

  normalizeLoading() {
    /**
     * Calculate the normalized loading configuration in case of custom user inputs in loading config section.
     *
     * Accounts for disabled loading types.
     */


        // Sum if enabled, otherwise ignore axle type, set to zero if value is negative
    const singlePct = (this.singlePct > 0 ? this.singlePct : 0) * (this.scenario.axleSingleEnabled ? 1 : 0);
    const tandemPct = (this.tandemPct > 0 ? this.tandemPct : 0) * (this.scenario.axleTandemEnabled ? 1 : 0);
    const tridemPct = (this.tridemPct > 0 ? this.tridemPct : 0) * (this.scenario.axleTridemEnabled ? 1 : 0);
    const steerPct = (this.steerPct > 0 ? this.steerPct : 0) * (this.scenario.axleSteerEnabled ? 1 : 0);

    const total = singlePct + tandemPct + tridemPct + steerPct;

    // Get normalized axle type distribution
    this.singlePct = (singlePct / total) * 100;
    this.tandemPct = (tandemPct / total) * 100;
    this.tridemPct = (tridemPct / total) * 100;
    this.steerPct = (steerPct / total) * 100;

    this.generateLoadDistributions();
    if (this.$v) {
      // @ts-ignore
      this.$v.singlePct.$touch();
      // @ts-ignore
      this.$v.tandemPct.$touch();
      // @ts-ignore
      this.$v.tridemPct.$touch();
      // @ts-ignore
      this.$v.steerPct.$touch();
    }

    this.sync();
  }

  /**
   * Axle Load Distributions
   */

  runGenerateLoadDistributions() {
    this.generateLoadDistributions();
    this.sync();
  }

  generateLoadDistributions() {
    this.scenario.axleLoadDistSingle = getNewLoadDistribution(PrAxleConfigurationType.SINGLE, this.scenario.vehiclesPctAadt);
    this.scenario.axleLoadDistTandem = getNewLoadDistribution(PrAxleConfigurationType.TANDEM, this.scenario.vehiclesPctAadt);
    this.scenario.axleLoadDistTridem = getNewLoadDistribution(PrAxleConfigurationType.TRIDEM, this.scenario.vehiclesPctAadt);
  }

  get axleWeights() {
    const weights = [];
    for (let i = 0; i < 110; i += 2) {
      weights.push(i);
    }
    return weights;
  }

  sync() {
    perRoadStore.setCurrentScenario(this.scenario);
    this.plotKey += 1;
    this.axleDistPlotKey += 1;
  }

  save() {
    this.sync();
    perRoadStore.saveCurrentScenario();
  }

  validations() {
    return createPerRoadValidations(this.scenarioImperial, this.page);
  }

  mounted() {
    this.setAxleStats();
    this.generateLoadDistributions();
  }
}

